import { createModel } from '@rematch/core';
import apiConnector from '../../api/ApiConnector';
import { AttestationCommissionDetails, IAccreditationCenters } from '../../api/ApiClient';
import { IAttestationCommissionsFilters } from 'components/reduxModels';

const initialState: State = {
    acList: null,
    acDetails: null,
};

export default createModel({
    state: initialState,
    reducers: {
        setAcList(state, acList: State['acList']): State {
            return { ...state, acList };
        },
        setAcDetails(state, acDetails: State['acDetails']): State {
            return { ...state, acDetails };
        },
        clearAcDetails(state): State {
            return { ...state, acDetails: null };
        },
    },
    effects: (dispatch: any) => ({
        async getAcAsync(payload: IAttestationCommissionsFilters) {
            this.setAcList(await apiConnector.execApi(
              dispatch,
              apiClient => apiClient.getAttestationCommissions(
                payload.qualificationIds,
                payload.regionId,
                payload.searchField,
                payload.searchTerm,
                payload.page,
                payload.pageSize,
                payload.sortOrder,
                payload.sortField,
              ),
            ));
        },
        async getAttestationCommission(acId: string) {
            this.setAcDetails(await apiConnector.execApi(
              dispatch,
              apiClient => apiClient.getAttestationCommission(acId),
            ));
        },
    }),
});

interface State {
    acList: IAccreditationCenters | null;
    acDetails: AttestationCommissionDetails | null;
}
